import type { users as en } from '@/i18n/locales/en/users';
import type { Translation } from '@/i18n/types';

export const users: Translation<typeof en> = {
  page: {
    title: 'Kullanıcılar',
    noScope: 'Herhangi bir yönetim kapsamınız yok, bu yüzden gösterilecek bir üye listesi yok.',
    departmentListsTitle: 'Departman üye listeleri',
    leadCompany: '{{company}} üyeleri.',
    membersOf: '{{company}} üyeleri',
    companyMembersCardTitle: 'Üyeler',
    addPerson: 'Kişi ekle',
    empty: 'Üye yok.',
    name: 'Ad',
    email: 'E-posta',
    login: 'Giriş',
    source: 'Kaynak',
    yes: 'evet',
    no: 'hayır',
    invitePerson: 'Davet et',
    importCsv: 'CSV içe aktar',
    searchPlaceholder: 'Ad veya e-posta ile ara…',
    filterDepartment: 'Departman',
    allDepartments: 'Tüm departmanlar',
    filterLocation: 'Konum',
    allLocations: 'Tüm konumlar',
    filterStatus: 'Durum',
    allStatuses: 'Tüm durumlar',
    employee: 'Çalışan',
    department: 'Departman',
    location: 'Konum',
    lastSync: 'Son senkronizasyon',
    consent: 'Onay',
    wearable: 'Giyilebilir cihaz',
    pilot: 'Pilot',
    account: 'Hesap',
    actions: 'İşlemler',
    accountActive: 'Aktif',
    accountDeactivated: 'Devre dışı',
    noLocation: 'Konum yok',
    noDepartment: 'Departman yok',
    activation: {
      label: 'Aktivasyon',
      invited: 'Davet edildi',
      activated: 'Etkinleştirildi',
      active: 'Aktif',
      inactive: 'Pasif',
      deactivated: 'Devre dışı',
    },
    consentStatus: {
      pending: 'Beklemede',
      confirmed: 'Onaylandı',
      declined: 'Geri çekildi',
      none: 'Yok',
    },
  },
  detail: {
    thisPerson: 'bu kişi',
    edit: 'Düzenle',
    name: 'Ad',
    email: 'E-posta',
    nickname: 'Takma ad',
    preferredLanguage: 'Tercih edilen dil',
    region: 'Bölge',
    login: 'Giriş',
    yes: 'evet',
    no: 'hayır',
    gender: 'Cinsiyet',
    birthdate: 'Doğum tarihi',
    height: 'Boy',
    weight: 'Kilo',
    privateNote:
      'Cinsiyet, doğum tarihi, boy ve kilo bu kişiye özeldir ve başkalarının onu görüş biçiminin bir parçası değildir.',
    actionsCardTitle: 'İşlemler',
    statsCardTitle: 'İstatistikler',
  },
  edit: {
    title: 'Kişisel bilgileri düzenle',
    lead: 'Ad ve e-posta, oturum açma hesabından gelir ve burada değiştirilemez.',
    cancel: 'İptal',
    save: 'Kaydet',
  },
  addPerson: {
    created: 'Kişi oluşturuldu.',
    inviteSent: 'Bir davet e-postası yolda.',
    alreadyHasLogin: 'Zaten girişleri var.',
    noLoginYet: 'Henüz girişleri yok — onları daha sonra üye listesinden davet edebilirsiniz.',
    done: 'Bitti',
    name: 'Ad',
    email: 'E-posta',
    emailHint: 'İsteğe bağlı — bir e-posta girilirse kişi oturum açmaya davet edilir.',
    nickname: 'Takma ad',
    region: 'Bölge',
    conflict:
      'Bu e-posta adresine sahip bir kişi zaten var{{reason}}. Yinelenen bir kayıt oluşturmak yerine bu mevcut kişiyi kapsama ekleyin.',
    cancel: 'İptal',
    create: 'Kişi oluştur',
    companyTitle: 'Şirkete bir kişi ekle',
    departmentTitle: 'Departmana bir kişi ekle',
    newPersonCardTitle: 'Yeni kişi',
    existingCardTitle: 'Mevcut şirket üyesi',
    existingPersonCardTitle: 'Mevcut kişi',
    member: 'Üye',
    person: 'Kişi',
    choose: 'Seçin…',
    addToDepartment: 'Departmana ekle',
    addToCompany: 'Şirkete ekle',
    searchPeople: 'Kişi ara',
    searchPlaceholder: 'Ad veya e-posta',
    noEligible: 'Eşleşen bir kişi bulunamadı.',
    editionMismatch:
      'Bu kişinin sürümü şirketinkinden farklı. Önce kişinin veya şirketin sürümünü değiştirin, ardından tekrar deneyin.',
  },
  actions: {
    invite: 'Davet et',
    inviteAgain: 'Tekrar davet et',
    changeEmail: 'E-postayı değiştir',
    newEmail: 'Yeni e-posta adresi',
    save: 'Kaydet',
    cancel: 'İptal',
    remove: 'Kaldır',
    unlink: 'Bağlantıyı kaldır',
    unlinkFromPilot: 'Pilottan bağlantıyı kaldır',
    erase: 'Sil',
    changeLocation: 'Konumu değiştir',
    changeDepartment: 'Departmanı değiştir',
    deactivate: 'Devre dışı bırak',
    activate: 'Etkinleştir',
  },
  invite: {
    title: 'Bir kişiyi davet et',
    name: 'Ad',
    email: 'E-posta adresi',
    role: 'Rol',
    roleMember: 'Çalışan',
    roleAdmin: 'Şirket yöneticisi',
    submit: 'Davet et',
    cancel: 'İptal',
  },
  import: {
    title: 'CSV içe aktar',
    instructions:
      'Şu sütunları içeren bir CSV yapıştırın veya yükleyin: ad, e-posta, departman, konum.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Veya bir dosya yükleyin',
    submit: 'İçe aktar',
    cancel: 'İptal',
    done: 'Bitti',
    summary: '{{imported}} içe aktarıldı, {{failed}} başarısız oldu.',
    rowLabel: 'Satır {{row}}',
    rowSuccess: 'İçe aktarıldı',
    rowFailed: 'Başarısız',
  },
};
